export const relayClient = 'relay'
export const franchiseClient = 'franchise'
